import { Location } from '@angular/common';
import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';
import { Temporal } from '@js-temporal/polyfill';
import { EMethodePrelevement } from 'src/app/domain/Air/enum/methode-prelevement';
import { EMilieuPrelevementAir } from 'src/app/domain/Air/enum/milieu-prelevement';
import { EConditionPrelevement } from 'src/app/domain/enums/condition-prelevement';
import { Zone } from 'src/app/domain/zone';
import { ENavigationRoute } from 'src/app/models/enums/navigation-route';

import { CoreData } from 'src/app/tools/core-data/core-data';

import { TextFieldModule } from '@angular/cdk/text-field';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _ from 'lodash';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { ConsommableRepository } from 'src/app/db/repository/consommable.repository';
import { FlaconRepository } from 'src/app/db/repository/flacon.repository';
import { InterventionRepository } from 'src/app/db/repository/intervention.repository';
import { PrelevementRepository } from 'src/app/db/repository/prelevement.repository';
import { QualifSalleRepository } from 'src/app/db/repository/qualif-salle.repository';
import { RepriseRepository } from 'src/app/db/repository/reprise.repository';
import { SoufflageRepository } from 'src/app/db/repository/soufflage.repository';
import { ZoneCompareRepository } from 'src/app/db/repository/zone-compare.repository';
import { ZoneRepository } from 'src/app/db/repository/zone.repository';
import { EConsommableAir } from 'src/app/domain/Air/enum/consommable-air';
import { ELieuPrelevementAir } from 'src/app/domain/Air/enum/lieu-prelevement';
import { EAirQFType } from 'src/app/domain/Qualif/enums/air-qf-type';
import { EClasse } from 'src/app/domain/Qualif/enums/classe';
import { EClasseBPP } from 'src/app/domain/Qualif/enums/classe-bpp';
import { EClasseBPPH } from 'src/app/domain/Qualif/enums/classe-bpph';
import { EClasseComptageParticulaire } from 'src/app/domain/Qualif/enums/classe-comptage-particulaire';
import { ELocalisationQualifSalle } from 'src/app/domain/Qualif/enums/localisation-salle';
import { ESystemeTraitementAir } from 'src/app/domain/Qualif/enums/systeme-traitement-air';
import { ETestFumee } from 'src/app/domain/Qualif/enums/test-fumee';
import { ETypeAppareil } from 'src/app/domain/Qualif/enums/type-appareil';
import { Reprise } from 'src/app/domain/Qualif/reprise';
import { Soufflage } from 'src/app/domain/Qualif/soufflage';
import { ZoneCompare } from 'src/app/domain/Qualif/zone-compare';
import { EConsommableSurface } from 'src/app/domain/Surface/enum/consommable-surface';
import { ELieuPrelevementSurface } from 'src/app/domain/Surface/enum/lieu-prelevement';
import { EMilieuPrelevementSurface } from 'src/app/domain/Surface/enum/milieu-prelevement';
import { PrelevementSurface } from 'src/app/domain/Surface/prelevement-surface';
import { Consommable } from 'src/app/domain/consommable';
import { EFlaskType } from 'src/app/domain/enums/flask-type';
import { EInterventionStatus } from 'src/app/domain/enums/intervention-status';
import { EServiceType } from 'src/app/domain/enums/service-type';
import { Flacon } from 'src/app/domain/flacon';
import { Intervention } from 'src/app/domain/intervention';
import { Prelevement } from 'src/app/domain/prelevement';
import { ECallerOfScan } from 'src/app/models/caller-of-scan';
import { ETaskStatus } from 'src/app/models/enums/task-status';
import { SimpleListModel } from 'src/app/models/simple-list-model';
import { StringTool } from 'src/app/tools/mapping/string.tool';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ConsommableBoxDialog } from 'src/app/tools/ui/consommable-box/consommable-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { RepriseBoxDialog } from 'src/app/tools/ui/reprise-box/reprise-box';
import { SoufflageBoxDialog } from 'src/app/tools/ui/soufflage-box/soufflage-box';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { ZoneCompareBoxDialog } from 'src/app/tools/ui/zone-compare-box/zone-compare-box';
import { PreventDoubleClickDirective } from '../../tools/directive/prevent-double-click.directive';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
    selector: 'app-zone',
    templateUrl: './zone.component.html',
    styleUrl: './zone.component.scss',
    standalone: true,
    imports: [ReactiveFormsModule, MatAutocompleteModule, MatFormFieldModule, MatInputModule, MatSlideToggleModule, NgxMaterialTimepickerModule, MatButtonModule, MatIconModule, MatDatepickerModule, FormsModule, MatSelectModule, MatOptionModule, TextFieldModule, PreventDoubleClickDirective]
})

export class ZoneComponent implements OnInit, AfterContentInit {
    EInterventionStatus = EInterventionStatus;
    ELieuPrelevementAir = ELieuPrelevementAir;
    ELieuPrelevementSurface = ELieuPrelevementSurface;
    EServiceType = EServiceType;
    ETypeAppareilQualif = ETypeAppareil;
    EAirQFType = EAirQFType;

    public MilieuPrelevementList: string[] = Object.values(EMilieuPrelevementAir)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getMilieuPrelevement(x));

    public MilieuPrelevementSurfaceList: string[] = Object.values(EMilieuPrelevementSurface)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getMilieuPrelevementSurface(x));

    public LieuPrelevementAirList: string[] = Object.values(ELieuPrelevementAir)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getLieuPrelevementAir(x));

    public LieuPrelevementSurfaceList: SimpleListModel[] = Object.values(ELieuPrelevementSurface)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => {
            // const slm = new SimpleListModel();
            // slm.idx = x as number;
            // return slm;
            return new SimpleListModel({ idx: x, s: StringConverter.getLieuPrelevementSurface(x) });
        });

    public MethodePrelevementAirList: string[] = Object.values(EMethodePrelevement)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getMethodePrelevement(x));

    public ConditionPrelevementList: string[] = Object.values(EConditionPrelevement)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getConditionPrelevement(x));

    public SystemeTraitemenrAirList: string[] = Object.values(ESystemeTraitementAir)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getSystemeTraitementAirLabel(x));

    public LocalisationSalleList: string[] = Object.values(ELocalisationQualifSalle)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getLocalisationQualifSalleLabel(x));

    public ClasseList: SimpleListModel[] = []

    public TestFumeeList: string[] = Object.values(ETestFumee)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getTestFumeeLabel(x));

    private zoneCode: string = '';
    private scannedCode: string = '';
    private propertyCode: string = '';
    Zone?: Zone;
    DateDerniereLavage?: Date;
    DefaultTime!: string;
    TimeSampling!: string
    TimeBionettoyage!: string
    _SamplingDate!: Date
    _BionettoyageDate!: Date
    ValidMinutesForHoraireInitial = new UntypedFormControl('', Validators.compose([Validators.min(0), Validators.max(59)]));
    ValidMinutesForHoraireFinal = new UntypedFormControl('', Validators.compose([Validators.min(0), Validators.max(59)]));
    // ValidBarcodeLength = new UntypedFormControl('', Validators.maxLength(15));
    filteredLieuPrelevementOptions: SimpleListModel[] = []
    // SearchLieuPrelevementText: string = '';

    Intervention: Intervention | undefined;

    constructor(
        private location: Location,
        private router: Router,
        private coreData: CoreData,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private zoneRepository: ZoneRepository,
        private prelevementRepository: PrelevementRepository,
        private consommableRepository: ConsommableRepository,
        private qualifSalleRepository: QualifSalleRepository,
        private repriseRepository: RepriseRepository,
        private soufflageRepository: SoufflageRepository,
        private zoneCompareRepository: ZoneCompareRepository,
        private flaconRepository: FlaconRepository,
        private interventionRepository: InterventionRepository) {

    }

    ngOnInit(): void {

        this.ValidMinutesForHoraireInitial.markAsTouched();
        this.ValidMinutesForHoraireFinal.markAsTouched();

        this.DefaultTime = `${Temporal.Now.plainDateTimeISO().hour}:${Temporal.Now.plainDateTimeISO().minute}`
    }

    async ngAfterContentInit(): Promise<void> {

        this.zoneCode = this.route.snapshot.params['zoneCode'];
        this.scannedCode = this.route.snapshot.params['result'];
        this.propertyCode = this.route.snapshot.params['propertyCode'];

        this.Intervention = await this.interventionRepository.getInterventionByZoneCode(this.zoneCode)

        this.Zone = await this.zoneRepository.getZoneByCodeWithChildren(this.zoneCode);

        if (!this.Zone)
            return;
        this.coreData.CurrentPageName = this.Zone.ZoneSalle;
        if (this.Zone.SamplingDate) {
            this.TimeSampling = `${this.Zone.SamplingDate.hour}:${this.Zone.SamplingDate.minute}`;
        }
        if (this.Zone.DateDernierLavage) {
            this.TimeBionettoyage = `${this.Zone.DateDernierLavage.hour}:${this.Zone.DateDernierLavage.minute}`;
        }

        if (this.Zone.DateDernierLavage)
            this.DateDerniereLavage = new Date(this.Zone.DateDernierLavage.year, this.Zone.DateDernierLavage.month - 1, this.Zone.DateDernierLavage.day)

        if (this.scannedCode) {
            this.Zone.PrelevementAirList.forEach(x => {
                let flalfla = x.Prelevement.FlaconList.find(y => y.Code === this.propertyCode)
                if (flalfla) {
                    flalfla.Barcode = this.scannedCode;
                    this.save(true)
                }
            });
        }

        this.Zone.PrelevementSurfaceList.forEach(x => {
            x.Prelevement.FlaconList.forEach(y => {
                let flalfla = x.Prelevement.FlaconList.find(y => y.Code === this.propertyCode)
                if (flalfla) {
                    flalfla.Barcode = this.scannedCode;
                    this.save(true)
                }
            });
        })

        this.filteredLieuPrelevementOptions = this.LieuPrelevementSurfaceList
        this.Zone.PrelevementSurfaceList.forEach(ps => {

            ps.SearchText = this.LieuPrelevementSurfaceList.find(x => x.idx === ps.LieuPrelevement)?.s ?? ''
        })

        if (this.Zone.PrelevementQualifSalle?.Type === EAirQFType.Standard)
            this.ClasseList = Object.values(EClasse)
                .filter(x => !isNaN(Number(x)))
                .map((x: any) => {
                    return new SimpleListModel({ idx: x, s: StringConverter.getClasseLabel(x) });
                });

        else if (this.Zone.PrelevementQualifSalle?.Type === EAirQFType.BPP) {
            this.ClasseList = Object.values(EClasseBPP)
                .filter(x => !isNaN(Number(x)))
                .map((x: any) => {
                    return new SimpleListModel({ idx: x, s: StringConverter.getClasseBPPLabel(x) });
                });
        }
        else if (this.Zone.PrelevementQualifSalle?.Type === EAirQFType.BPPH) {
            this.ClasseList = Object.values(EClasseBPPH)
                .filter(x => !isNaN(Number(x)))
                .map((x: any) => {
                    return new SimpleListModel({ idx: x, s: StringConverter.getClasseBPPHLabel(x) });
                });
        }
        else if (this.Zone.PrelevementQualifSalle?.Type === EAirQFType.ComptageParticulaire) {
            this.ClasseList = Object.values(EClasseComptageParticulaire)
                .filter(x => !isNaN(Number(x)))
                .map((x: any) => {
                    return new SimpleListModel({ idx: x, s: StringConverter.getClasseComptageParticulaireLabel(x) });
                });
        }
    }

    getFlaskTypeLabel(type: EFlaskType) {
        return StringConverter.getFlaskTypeLabel(type);
    }

    getConsommableAirLabel(type: EConsommableAir) {
        return StringConverter.getConsommableAirLabel(type);
    }

    getConsommableSurfaceLabel(type: EConsommableSurface) {
        return StringConverter.getConsommableSurfaceLabel(type);
    }

    getLieuPrelevementSurfaceLabel(type: ELieuPrelevementSurface) {
        return StringConverter.getLieuPrelevementSurface(type);
    }

    filterLieuPrelevementList(prel: PrelevementSurface) {
        this.filteredLieuPrelevementOptions = this.LieuPrelevementSurfaceList.filter(x => x.s.toLowerCase().startsWith(prel.SearchText.toLowerCase()))
    }

    onSelectionChange(prel: PrelevementSurface, event: MatAutocompleteSelectedEvent) {

        if (!prel)
            return;
        prel.LieuPrelevement = event.option.value.idx;
        prel.SearchText = this.LieuPrelevementSurfaceList.find(x => x.idx === prel.LieuPrelevement)!.s

        this.filteredLieuPrelevementOptions = this.LieuPrelevementSurfaceList
    }

    canBeDisabled(flacon: Flacon) {

        return flacon.Barcode !== null && flacon.Barcode !== '' && flacon.Barcode.length >= 13 &&

            !(this.Zone?.PrelevementAirList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().find(y => y.Code !== flacon.Code && y.Barcode === flacon.Barcode)
                || this.Zone?.PrelevementSurfaceList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().find(y => y.Code !== flacon.Code && y.Barcode === flacon.Barcode));
    }

    getUniquePSV() {
        if (!this.Zone)
            return;

        return _.uniqBy([
            ...this.Zone.PrelevementAirList.map(x => x.Prelevement.SamplingPoint),
            ...this.Zone.PrelevementSurfaceList.map(x => x.Prelevement.SamplingPoint)
        ], x => x.Name);
    }

    checkBarCode(event: KeyboardEvent, barCode: string) {
        if (!barCode)
            return;

        if (barCode.length >= 14) {
            event.preventDefault()
        }
    }

    public focusNext(barcode: string, j: number, i: number, type: EServiceType, size: number) {


        var regex = /H0\d+/g
        let success = regex.test(barcode)
        // success = true
        if (!barcode || barcode.length < 13 || !success ||
            (type === EServiceType.Surface && j === this.Zone!.PrelevementSurfaceList.length - 1) ||
            (type === EServiceType.Air && j === this.Zone!.PrelevementAirList.length - 1 && i === this.Zone!.PrelevementAirList[j].Prelevement.FlaconList.length - 1)) {
            return;
        }


        let nextElementSiblingId;
        if (i < size - 1)
            nextElementSiblingId = `barcode${type}-${j}-${i + 1}`;
        else
            nextElementSiblingId = `barcode${type}-${j + 1}-${i}`;

        (document.querySelector(`#${nextElementSiblingId}`)! as any).focus()

    }

    async checkBarCodeExistence(code: string, barcode: string, j: number, i: number, type: EServiceType, size: number) {

        if (!barcode || barcode.length < 13)
            return

        let flacon = this.Zone?.PrelevementAirList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().find(y => y.Code === code) ??
            this.Zone?.PrelevementSurfaceList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().find(y => y.Code === code)
        if (flacon
            && (this.Zone?.PrelevementAirList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().find(y => y.Code !== flacon.Code && y.Barcode === flacon.Barcode)
                || this.Zone?.PrelevementSurfaceList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().find(y => y.Code !== flacon.Code && y.Barcode === flacon.Barcode)
                || await this.flaconRepository.checkIfBarcodeExists(flacon.Barcode))) {
            NotificationManager.handleError('Barcode déjà scanné !', this.snackBar)
            console.log(flacon);
            flacon.Barcode = ''
        }
        else
            // if (code.length === 13) {
            this.focusNext(barcode, j, i, type, size)
        // }
    }

    async deleteConsommable(cons: Consommable, prel: Prelevement, typeOfService: EServiceType) {
        let sameTypeOfServiceIntervenList = await this.interventionRepository.getInterventionListWithZoneOnly();
        let prelevementList;

        switch (typeOfService) {
            case EServiceType.Surface:
                this.Zone!.PrelevementSurfaceList.forEach(x => _.remove(x.Prelevement.ConsommableList, y => y.NumeroLot === cons.NumeroLot))
                prelevementList = sameTypeOfServiceIntervenList.map(x => x.ZoneList.map(y => y.PrelevementSurfaceList.map(z => z.Prelevement))).flat(2)
                break;
            case EServiceType.Air:
                this.Zone!.PrelevementAirList.forEach(x => _.remove(x.Prelevement.ConsommableList, y => y.NumeroLot === cons.NumeroLot))
                prelevementList = sameTypeOfServiceIntervenList.map(x => x.ZoneList.map(y => y.PrelevementAirList.map(z => z.Prelevement))).flat(2)
                break;
        }

        prelevementList?.forEach(async x => {
            x.ConsommableList.forEach(async y => {
                await this.consommableRepository.deleteConsommableByNumeroLot((await this.prelevementRepository.getPrelevementEntityByCode(x.Code))!)
            })
        })

        // await this.consommableRepository.deleteConsommableById(cons.Id!, (await this.prelevementRepository.getPrelevementEntityByCode(prel.Code))!);
        // _.remove(prel.ConsommableList, x => x.Id === cons.Id)
    }

    dateDernierLavageChanged(event: MatDatepickerInputEvent<Date>) {
        // if (this.Zone?.DateDernierLavage) {
        //     return;
        // }
        this.DateDerniereLavage ??= new Date();
        this.Zone!.DateDernierLavage = Temporal.PlainDateTime.from({
            year: this.DateDerniereLavage.getFullYear(),
            day: this.DateDerniereLavage.getDate(),
            month: this.DateDerniereLavage.getMonth() + 1,
            hour: this.Zone!.DateDernierLavage ? this.Zone!.DateDernierLavage.hour : this.DateDerniereLavage.getHours(),
            minute: this.Zone!.DateDernierLavage ? this.Zone!.DateDernierLavage.minute : this.DateDerniereLavage.getMinutes()
        });
    }

    clearSampling() {
        this.TimeSampling = '';
        this.Zone!.SamplingDate = undefined;
    }

    clearBionettoyage() {
        this.TimeBionettoyage = '';
        this.Zone!.DateDernierLavage = undefined;
    }

    timeSetSampling(event: string) {
        if (!this.Zone)
            return;
        const time = event.split(':');
        // this.Zone.SamplingDate = Temporal.Now.plainDateTimeISO();
        this._SamplingDate = new Date();
        this._SamplingDate.setHours(Number(time[0]), Number(time[1]));
        this.Zone.SamplingDate = Temporal.PlainDateTime.from({
            year: this._SamplingDate.getFullYear(),
            day: this._SamplingDate.getDate(),
            month: this._SamplingDate.getMonth() + 1,
            hour: this._SamplingDate.getHours(),
            minute: this._SamplingDate.getMinutes()
        });
        this.setTimeSampling();
    }

    setTimeSampling() {
        this.TimeSampling = `${this._SamplingDate.getHours()}:${this._SamplingDate.getMinutes()}`;
    }

    timeSetBionettoyage(event: string) {
        if (!this.Zone)
            return;
        const time = event.split(':');
        // this.Zone.DateDernierLavage = Temporal.Now.plainDateTimeISO();
        this._BionettoyageDate = new Date();
        this._BionettoyageDate.setHours(Number(time[0]), Number(time[1]));
        this.Zone.DateDernierLavage = Temporal.PlainDateTime.from({
            year: this.Zone.DateDernierLavage?.year ? this.Zone.DateDernierLavage.year : this._BionettoyageDate.getFullYear(),
            day: this.Zone.DateDernierLavage?.day ? this.Zone.DateDernierLavage.day : this._BionettoyageDate.getDate(),
            month: this.Zone.DateDernierLavage?.month ? this.Zone.DateDernierLavage.month : this._BionettoyageDate.getMonth() + 1,
            hour: this._BionettoyageDate.getHours(),
            minute: this._BionettoyageDate.getMinutes()
        });
        this.setTimeBionettoyage();
    }

    setTimeBionettoyage() {
        this.TimeBionettoyage = `${this._BionettoyageDate.getHours()}:${this._BionettoyageDate.getMinutes()}`;
    }
    openBarcodeScanning(code: string) {
        this.save(true);
        // this.coreData.ScannedId = `${cassetteId}`;
        this.router.navigate([ENavigationRoute.Scan, { pageCode: this.zoneCode, propertyCode: code, callerPageType: ECallerOfScan.Zone }]);
    }

    checkIfThereAreAtLeastOneConsommableWhereThereIsABarCode() {
        for (let i = 0, pa = this.Zone!.PrelevementAirList[i]; i < this.Zone!.PrelevementAirList.length!; i++) {

            for (let j = 0, flafla = pa.Prelevement.FlaconList[j]; j < pa.Prelevement.FlaconList.length; j++) {

                if (flafla.Barcode && pa.Prelevement.ConsommableList.length === 0)

                    return false;
            }
        }

        for (let i = 0, pa = this.Zone!.PrelevementSurfaceList[i]; i < this.Zone!.PrelevementSurfaceList.length!; i++) {

            for (let j = 0, flafla = pa.Prelevement.FlaconList[j]; j < pa.Prelevement.FlaconList.length; j++) {

                if (flafla.Barcode && pa.Prelevement.ConsommableList.length === 0)

                    return false;
            }
        }

        return true;
    }

    hasPlan(plan: string) {
        if (StringTool.isNotNullOrEmpty(plan))
            return true;
        return false;
    }

    openConsommableBox(typeOfService: EServiceType, prel: Prelevement, milieu: EMilieuPrelevementAir | EMilieuPrelevementSurface, cons?: Consommable) {
        const dialogRef = this.dialog.open(ConsommableBoxDialog, {
            data: {
                typeOfService,
                milieu: milieu,
                consommable: cons,
                interventionCode: this.Intervention?.Code
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(async (result: Consommable) => {
            if (result) {
                // await db.updateLastUsedConsommableByType(result, typeOfService)
                // result.Id = await this.consommableRepository.attachConsommable(result, (await this.prelevementRepository.getPrelevementEntityByCode(prel.Code))!);
                // prel.ConsommableList.push(result)
                switch (typeOfService) {
                    case EServiceType.Surface:
                        this.Zone!.PrelevementSurfaceList.forEach(x => x.Prelevement.ConsommableList.push(result))
                        break;
                    case EServiceType.Air:
                        this.Zone!.PrelevementAirList.forEach(x => x.Prelevement.ConsommableList.push(result))
                        break;
                }
                NotificationManager.handleSuccess('Consommable ajouté', this.snackBar);
            }
        });
    }

    openRepriseBox(reprise?: Reprise) {
        const dialogRef = this.dialog.open(RepriseBoxDialog, {
            data: {
                reprise: reprise,
                lastLongueur: _.last(this.Zone?.PrelevementQualifSalle?.RepriseList)?.Longueur,
                lastLargeur: _.last(this.Zone?.PrelevementQualifSalle?.RepriseList)?.Largeur
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(async (result: Reprise) => {
            if (result) {
                if (reprise) {
                    await this.repriseRepository.updateReprise(result)
                    NotificationManager.handleSuccess('Reprise modifiée', this.snackBar);
                } else {

                    result.Id = await this.repriseRepository.attachReprise(result, (await this.qualifSalleRepository.getQualifSalleEntityByCode(this.Zone!.PrelevementQualifSalle!.Code))!);
                    this.Zone?.PrelevementQualifSalle?.RepriseList.push(result);
                    NotificationManager.handleSuccess('Reprise ajoutée', this.snackBar);
                }
            }
        });
    }

    openSoufflageBox(soufflage?: Soufflage) {
        const dialogRef = this.dialog.open(SoufflageBoxDialog, {
            data: {
                soufflage: soufflage,
                lastLongueur: _.last(this.Zone?.PrelevementQualifSalle?.SoufflageList)?.Longueur,
                lastLargeur: _.last(this.Zone?.PrelevementQualifSalle?.SoufflageList)?.Largeur
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(async (result: Soufflage) => {
            if (result) {
                if (soufflage) {
                    await this.soufflageRepository.updateSoufflage(result)
                    NotificationManager.handleSuccess('Soufflage modifiée', this.snackBar);
                } else {

                    result.Id = await this.soufflageRepository.attachSoufflage(result, (await this.qualifSalleRepository.getQualifSalleEntityByCode(this.Zone!.PrelevementQualifSalle!.Code))!);
                    this.Zone?.PrelevementQualifSalle?.SoufflageList.push(result);
                    NotificationManager.handleSuccess('Soufflage ajouté', this.snackBar);
                }
            }
        });
    }

    openZoneCompareBox(isForSAS: boolean, zoneCompare?: ZoneCompare) {
        const dialogRef = this.dialog.open(ZoneCompareBoxDialog, {
            data: zoneCompare,
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(async (result: ZoneCompare) => {
            result && (isForSAS ? await this.updateZoneCompareSAS(result, !!zoneCompare) : await this.updateZoneCompareInterieur(result, !!zoneCompare));
        });
    }

    async updateZoneCompareInterieur(result: ZoneCompare, isCreation: boolean) {
        if (isCreation) {
            await this.zoneCompareRepository.updateZoneCompare(result)
            NotificationManager.handleSuccess('Zone intérieur à comparer modifiée', this.snackBar);
        } else {

            result.Id = await this.zoneCompareRepository.attachZoneCompare(result, (await this.qualifSalleRepository.getQualifSalleEntityByCode(this.Zone!.PrelevementQualifSalle!.Code))!);
            this.Zone?.PrelevementQualifSalle?.ZoneAComparerList.push(result);
            NotificationManager.handleSuccess('Zone intérieur à comparer ajoutée', this.snackBar);
        }
    }

    async updateZoneCompareSAS(zoneCompare: ZoneCompare, isCreation: boolean) {
        if (isCreation) {
            await this.zoneCompareRepository.updateZoneCompare(zoneCompare)
            NotificationManager.handleSuccess('Zone SAS à comparer modifiée', this.snackBar);
        } else {

            zoneCompare.Id = await this.zoneCompareRepository.attachZoneCompareSAS(zoneCompare, (await this.qualifSalleRepository.getQualifSalleEntityByCode(this.Zone!.PrelevementQualifSalle!.Code))!);
            this.Zone?.PrelevementQualifSalle?.ZoneAComparerSasList.push(zoneCompare);
            NotificationManager.handleSuccess('Zone SAS à comparer ajoutée', this.snackBar);
        }
    }

    async deleteReprise(reprise: Reprise) {
        await this.repriseRepository.deleteRepriseById(reprise.Id!, (await this.qualifSalleRepository.getQualifSalleEntityByCode(this.Zone!.PrelevementQualifSalle!.Code))!);
        _.remove(this.Zone!.PrelevementQualifSalle!.RepriseList, x => x.Id === reprise.Id)
    }

    async deleteSoufflage(soufflage: Soufflage) {
        await this.soufflageRepository.deleteSoufflageById(soufflage.Id!, (await this.qualifSalleRepository.getQualifSalleEntityByCode(this.Zone!.PrelevementQualifSalle!.Code))!);
        _.remove(this.Zone!.PrelevementQualifSalle!.SoufflageList, x => x.Id === soufflage.Id)
    }

    async deleteZoneAComparer(zoneCompare: ZoneCompare, isForSAS: boolean) {
        await this.zoneCompareRepository.deleteZoneCompareById(zoneCompare.Id!, (await this.qualifSalleRepository.getQualifSalleEntityByCode(this.Zone!.PrelevementQualifSalle!.Code))!);
        if (isForSAS) {
            _.remove(this.Zone!.PrelevementQualifSalle!.ZoneAComparerSasList, x => x.Id === zoneCompare.Id)
        } else {
            _.remove(this.Zone!.PrelevementQualifSalle!.ZoneAComparerList, x => x.Id === zoneCompare.Id)
        }
    }

    canSave() {
        // let missingBarCodes = [
        //     // ...this.Zone?.PrelevementAirList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().filter(y => !StringTool.isNotNullOrEmpty(y.Barcode)).map(z => z.Code)!,
        //     // ...this.Zone?.PrelevementSurfaceList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().filter(y => !StringTool.isNotNullOrEmpty(y.Barcode)).map(z => z.Code)!
        //     ...this.Zone?.PrelevementAirList.filter(x => x.Prelevement.FlaconList.every(y => !StringTool.isNotNullOrEmpty(y.Barcode))).map(z => z.Prelevement.OgiCode)!,
        //     ...this.Zone?.PrelevementSurfaceList.filter(x => x.Prelevement.FlaconList.every(y => !StringTool.isNotNullOrEmpty(y.Barcode))).map(z => z.Prelevement.OgiCode)!
        // ]

        // !this.Zone?.PrelevementQualifSalle.Luminosite || this.Zone?.PrelevementQualifSalle?.Luminosite < 0 ||
        // !this.Zone?.PrelevementQualifSalle?.PressionAcoustique || this.Zone?.PrelevementQualifSalle?.PressionAcoustique < 0)
        if (this.Zone?.PrelevementQualifSalle &&
            (!this.Zone?.PrelevementQualifSalle.SurfaceZAC || this.Zone?.PrelevementQualifSalle.SurfaceZAC < 0 ||
                !this.Zone?.PrelevementQualifSalle.Volume || this.Zone?.PrelevementQualifSalle.Volume < 0 ||
                (this.Zone?.PrelevementQualifSalle.Luminosite && this.Zone?.PrelevementQualifSalle.Luminosite < 0) ||
                (this.Zone?.PrelevementQualifSalle.PressionAcoustique && this.Zone?.PrelevementQualifSalle.PressionAcoustique < 0) ||
                (!this.Zone?.PrelevementQualifSalle.Humidite || this.Zone?.PrelevementQualifSalle.Humidite < 0 || this.Zone?.PrelevementQualifSalle.Humidite > 100))) {
            NotificationManager.handleWarning('Vous n\'avez pas saisi : Surface ZAC, Volume ZAC, T°, Luminosité, Heure, etc..', this.snackBar)
            return false;
        }

        let alreadyScannedBarCodes = [
            ...this.Zone?.PrelevementAirList.filter(x => x.Prelevement.FlaconList.some(y => StringTool.isNotNullOrEmpty(y.Barcode)))!,
            ...this.Zone?.PrelevementSurfaceList.filter(x => x.Prelevement.FlaconList.some(y => StringTool.isNotNullOrEmpty(y.Barcode)))!
        ]

        let missingSamplingDate = this.Zone?.SamplingDate ? false : true

        if (alreadyScannedBarCodes.length === 0 || (alreadyScannedBarCodes.length > 0 && !missingSamplingDate))
            return true;

        if (alreadyScannedBarCodes.length > 0 && missingSamplingDate) {
            NotificationManager.handleWarning('Heure de prélèvement obligatoire', this.snackBar)
        }
        return false;
    }

    async showAlert(withFinishedFlag: boolean) {

        let missingBarCodes = [
            // ...this.Zone?.PrelevementAirList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().filter(y => !StringTool.isNotNullOrEmpty(y.Barcode)).map(z => z.Code)!,
            // ...this.Zone?.PrelevementSurfaceList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().filter(y => !StringTool.isNotNullOrEmpty(y.Barcode)).map(z => z.Code)!
            ...this.Zone?.PrelevementAirList.filter(x => x.Prelevement.FlaconList.every(y => !StringTool.isNotNullOrEmpty(y.Barcode))).map(z => z.Prelevement.OgiCode)!,
            ...this.Zone?.PrelevementSurfaceList.filter(x => x.Prelevement.FlaconList.every(y => !StringTool.isNotNullOrEmpty(y.Barcode))).map(z => z.Prelevement.OgiCode)!
        ]
        // let SamplingDateIsSet = this.Zone?.SamplingDate ? true : false
        if (missingBarCodes.length === 0) {
            await this.save(withFinishedFlag)
            return;
        }
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: {
                message: `Enregistrer avec ces informations manquantes ?
                        ${missingBarCodes.length > 0 ? `Code à barres:\n ${missingBarCodes.join('\n')}` : ''} `,
                withCancelButton: true
            },
            height: '80%',
        });
        dialogRef.afterClosed().subscribe(async (result: boolean) => {
            if (result) {
                await this.save(withFinishedFlag)
                return;
            }
        })
    }

    async save(withFinishedFlag: boolean, quiet?: boolean) {
        if (!this.canSave()) {
            return
        }
        // console.log(this.Zone?.PrelevementAirList.map(x => x.Prelevement.FlaconList.filter(y => y.Barcode !== null).length).reduce(z => z))
        // console.log(this.Zone?.PrelevementAirList.map(x => x.Prelevement.ConsommableList.filter(y => y.NumeroLot !== null).length).reduce(z => z))

        // console.log(this.Zone?.PrelevementSurfaceList.map(x => x.Prelevement.FlaconList.filter(y => y.Barcode !== null).length).reduce(z => z))
        // console.log(this.Zone?.PrelevementSurfaceList.map(x => x.Prelevement.ConsommableList.filter(y => y.NumeroLot !== null).length).reduce(z => z))

        // !quiet && this.Zone?.PrelevementAirList.map(x => x.Prelevement.FlaconList.filter(y => y.Barcode !== null).length).reduce(z => z) !== this.Zone?.PrelevementAirList.map(x => x.Prelevement.ConsommableList.filter(y => y.NumeroLot !== null).length).reduce(z => z) ||
        //     this.Zone?.PrelevementSurfaceList.map(x => x.Prelevement.FlaconList.filter(y => y.Barcode !== null).length).reduce(z => z) !== this.Zone?.PrelevementSurfaceList.map(x => x.Prelevement.ConsommableList.filter(y => y.NumeroLot !== null).length).reduce(z => z)
        // if (!this.checkIfThereAreAtLeastOneConsommableWhereThereIsABarCode()) {
        //     NotificationManager.handleSuccess('Vous devez remplir au moins 1 consommable par prélèvement effectué', this.snackBar);
        //     return;
        // }
        if (withFinishedFlag)
            this.Zone!.TaskStatus = ETaskStatus.Done;

        const success = await this.zoneRepository.updateZone(this.Zone!);

        if (success && !quiet) {
            NotificationManager.handleSuccess('Données enregistrées', this.snackBar);
            this.location.back()
        } else if (!success) {
            NotificationManager.handleError('Wasted Bro!', this.snackBar);
        }
    }


    calculerNombrePoints(surface: number): number {

        if (surface <= 2) return 1;
        if (surface <= 4) return 2;
        if (surface <= 6) return 3;
        if (surface <= 8) return 4;
        if (surface <= 10) return 5;
        if (surface <= 24) return 6;
        if (surface <= 28) return 7;
        if (surface <= 32) return 8;
        if (surface <= 36) return 9;
        if (surface <= 52) return 10;
        if (surface <= 56) return 11;
        if (surface <= 64) return 12;
        if (surface <= 68) return 13;
        if (surface <= 72) return 14;
        if (surface <= 76) return 15;
        if (surface <= 104) return 16;
        if (surface <= 108) return 17;
        if (surface <= 116) return 18;
        if (surface <= 148) return 19;
        if (surface <= 156) return 20;
        if (surface <= 192) return 21;
        if (surface <= 232) return 22;
        if (surface <= 276) return 23;
        if (surface <= 352) return 24;
        if (surface <= 436) return 25;
        if (surface <= 636) return 26;
        if (surface <= 1000) return 27;

        return 28;
    }

    cleanAllBarcodes() {
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: {
                message: `Voulez-vous effacer tous les codes à barres ?`,
                withCancelButton: true
            },
            height: '80%',
        });
        dialogRef.afterClosed().subscribe(async (result: boolean) => {
            if (result) {

                this.Zone?.PrelevementAirList.forEach(x => {
                    this.prelevementRepository.clearBarCodeInPrelevement(x.Prelevement)
                })

                this.Zone?.PrelevementSurfaceList.forEach(x => {
                    this.prelevementRepository.clearBarCodeInPrelevement(x.Prelevement)
                })

                if (this.Zone?.PrelevementQualifSalle) {
                    this.prelevementRepository.clearBarCodeInPrelevement(this.Zone.PrelevementQualifSalle.Prelevement)
                }
            }
        })
    }
}

